import React, { useState } from 'react';
import Icon from 'components/AppIcon';

// Pre-defined pastel colors for tags
const TAG_COLORS = [
    'bg-blue-100 text-blue-800 border-blue-200',
    'bg-green-100 text-green-800 border-green-200',
    'bg-purple-100 text-purple-800 border-purple-200',
    'bg-yellow-100 text-yellow-800 border-yellow-200',
    'bg-pink-100 text-pink-800 border-pink-200',
    'bg-indigo-100 text-indigo-800 border-indigo-200',
    'bg-red-100 text-red-800 border-red-200',
    'bg-orange-100 text-orange-800 border-orange-200',
];

const getTagColor = (index) => TAG_COLORS[index % TAG_COLORS.length];

const TagManager = ({ title, tags = [], onAdd, onRemove, placeholder = "Add new..." }) => {
    const [isAdding, setIsAdding] = useState(false);
    const [newValue, setNewValue] = useState('');

    const handleAdd = () => {
        if (newValue.trim()) {
            onAdd(newValue.trim());
            setNewValue('');
            setIsAdding(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleAdd();
        } else if (e.key === 'Escape') {
            setIsAdding(false);
            setNewValue('');
        }
    };

    return (
        <div className="bg-card text-card-foreground rounded-2xl shadow-sm p-6">
            <h3 className="text-lg font-semibold mb-6 text-text-primary">{title}</h3>

            <div className="flex flex-wrap gap-3">
                {tags && tags.length > 0 ? (
                    tags.map((tag, index) => (
                        <div
                            key={`${tag}-${index}`}
                            className={`flex items-center px-4 py-2 rounded-full border ${getTagColor(index)} text-sm font-medium transition-all hover:shadow-sm group`}
                        >
                            <span className="mr-2">{tag}</span>
                            <button
                                onClick={() => onRemove(tag)}
                                className="opacity-60 group-hover:opacity-100 hover:text-red-600 focus:outline-none transition-opacity"
                                aria-label={`Remove ${tag}`}
                            >
                                <Icon name="X" size={14} />
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="text-text-secondary text-sm italic w-full mb-2">No tags added yet.</p>
                )}

                {/* Add Tag Button / Input */}
                {isAdding ? (
                    <div className="flex items-center">
                        <input
                            autoFocus
                            type="text"
                            value={newValue}
                            onChange={(e) => setNewValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            onBlur={() => {
                                // Optional: auto-save on blur, or cancel. Let's cancel to prevent accidental adds.
                                if (!newValue.trim()) setIsAdding(false);
                            }}
                            placeholder={placeholder}
                            className="flex-1 min-w-[120px] px-4 py-2 rounded-full border border-primary-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none text-sm"
                        />
                        <button
                            onClick={handleAdd}
                            className="ml-2 w-8 h-8 flex items-center justify-center bg-primary text-primary-foreground rounded-full hover:bg-primary-dark transition-colors"
                        >
                            <Icon name="Check" size={14} />
                        </button>
                        <button
                            onClick={() => setIsAdding(false)}
                            className="ml-1 w-8 h-8 flex items-center justify-center text-red-500 hover:bg-red-50 rounded-full transition-colors"
                        >
                            <Icon name="X" size={14} />
                        </button>

                    </div>
                ) : (
                    <button
                        onClick={() => setIsAdding(true)}
                        className="flex items-center px-4 py-2 rounded-full border border-dashed border-border text-text-secondary hover:text-primary hover:border-primary hover:bg-primary-50 transition-all text-sm font-medium"
                    >
                        <Icon name="Plus" size={16} className="mr-2" />
                        Add Tag
                    </button>
                )}
            </div>
        </div>
    );
};

export default TagManager;
